var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVttSplitTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LandingPage-SplitTickets-1440",
    transform: "translate(-1142, -1913)",
    fill: "#2D2D2D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-to-book-ST",
    transform: "translate(0, 1544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(732, 64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-2",
    transform: "translate(0, 271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(410, 34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.132,16 L4.266,13.857 L2.135,13.857 L2.135,11.849 L5.566,8.404 C5.788,8.181 5.788,7.819 5.566,7.596 L2.135,4.152 L2.135,2.143 L15.936,2.143 L18.07,0 L2.135,0 C0.956,0 0,0.959 0,2.143 L0,5.037 L2.549,7.596 C2.771,7.819 2.771,8.181 2.549,8.404 L0,10.963 L0,13.857 C0,15.04 0.954,15.999 2.132,16",
    id: "Fill-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.868,0 L5.93,16 L21.865,16 C23.044,16 24,15.041 24,13.857 L24,10.963 L21.451,8.404 C21.229,8.181 21.229,7.819 21.451,7.596 L24,5.037 L24,2.143 C24,0.96 23.046,0.001 21.868,0",
    id: "Fill-16"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVttSplitTicket);
export default __webpack_public_path__ + "static/media/icon-vtt-split-ticket.687c0dcc66170734738cc3490108b174.svg";
export { ForwardRef as ReactComponent };